

export default {
  name: 'upload-file-visites-medicales',
  components: {},
  props: ["element","programmation"],
  data () {
    return {
      loading:false,
      files: [],
      file_error: false,
      fichier_programmation: {
        programmation_vm: null,
      },
    }
  },
  computed: {
    user(){
      return this.$store.getters["authInfo"];
    },
    activeRole(){
      return this.$store.getters["activeRole"];
    },

  },
  mounted () {
    console.log(this.$route.name)
  },
  methods: {
    handleFilesUpload() {
      let uploadedFiles = this.$refs.vm_files.files;
      /**
      * Adds the uploaded file to the files array
      */
      this.files = [];

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }
      this.fichier_programmation.programmation_vm = this.files[0];

      this.file_error = false;
    },
    onSubmit(){
      this.$refs.upload_file_vm_form.validate().then((success) => {
        if(!success || this.files.length ==0){
          this.file_error= true
          return ;
        }
        this.loading = true
        let form_data = new FormData();

        form_data.append("programmation_vm",this.fichier_programmation.programmation_vm)

        
        
        if(this.$route.name === 'VisiteMedicalePendingResultList'){
          console.log('cc')
          //alert(this.$route.name)
        }
        
        this.$store.dispatch("uploadFileVisiteMedicale",{id:this.programmation.programmation_id,data:form_data}).then(
          () => {
            this.files = []
            this.$refs.upload_file_vm_form.reset()
            this.doSuccessMsg("Le résultat a été ajouté avec succès")
            this.loading = false
            this.$refs.upload_vm_close.click()

          },error=>{
              this.loading = false
              console.log(error)            
          }
        )


      }

      )
    },
    doSuccessMsg: function(msg) {
      this.$toasted.show(msg, {
          action: [{
              text: 'X',
              onClick: (e, toastObject) => {
                  toastObject.goAway(0);
              }
          }],
          position: 'top-center',
          duration: 5000,
          theme: 'toasted-primary',
          type: 'success'
      })
    },
    

  }
}


